import actions from "@/store/actions/userInfoAction";
import mutations from "@/store/mutations/userInfoMutation";
import getters from "@/store/getters/userInfoGetter";
/**
 *  mask
 */

export default {
  state: {
    deviceId: "device.uuid",
    serviceList: [],
    userMsg: {
      nickName: "",
      birthday: "",
      gender: "",
      birthdayMonth: 0,
      birthdayDay: 0
    },
    ratedUs: false,
    vipCloseCount: 0
  },
  mutations: mutations,
  actions: actions,
  getters: getters
};